import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";
import LanguageSwitcher from "@/components/LanguageSwitcher";

/**
 * Square theme toggle button — dark is the default site-wide.
 * Click cycles between dark and light. Icon inside changes accordingly.
 * The language switcher sits right beside it everywhere the toggle appears.
 */
export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const isDark = theme === "dark";
  return (
    <span className="inline-flex items-center gap-1.5 sm:gap-2">
    <LanguageSwitcher />
    <button
      type="button"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      data-testid="theme-toggle-btn"
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
      title={isDark ? "Switch to light" : "Switch to dark"}
      className="inline-flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 rounded-md border border-zinc-300 dark:border-zinc-700 bg-white/70 dark:bg-zinc-900/70 text-zinc-700 dark:text-zinc-200 hover:bg-zinc-100 dark:hover:bg-zinc-800 hover:border-zinc-400 dark:hover:border-zinc-600 transition-colors focus:outline-none focus:ring-2 focus:ring-[#FF4500]/50"
    >
      {isDark ? <Moon size={16} /> : <Sun size={16} />}
    </button>
    </span>
  );
}
